import { render } from "./PasswordResetError.vue?vue&type=template&id=2a27c8fb&scoped=true&ts=true"
import script from "./PasswordResetError.vue?vue&type=script&lang=ts"
export * from "./PasswordResetError.vue?vue&type=script&lang=ts"

import "./PasswordResetError.vue?vue&type=style&index=0&id=2a27c8fb&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a27c8fb"]])

export default __exports__